import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface PDFViewerDialogData {
  title?: string
  pdf?: string
}

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'pdf-viewer-dialog',
  },
  selector: 'pdf-viewer-dialog',
  styleUrls: ['pdf-viewer-dialog.component.scss'],
  templateUrl: './pdf-viewer-dialog.component.html',
})
export class PDFViewerDialog {
  public title: string
  public pdfUrl: SafeResourceUrl
  public isLoading = true

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: PDFViewerDialogData = {},
    public dialogRef: MatDialogRef<PDFViewerDialog>,
    private sanitizer: DomSanitizer,
  ) {
    this.title = data.title;
    this.pdfUrl = sanitizer.bypassSecurityTrustResourceUrl(data.pdf);
  }

  onLoadIframe(): void {
    setTimeout(() => {
      this.isLoading = false;
    });
  }
}
